import { filter } from 'lodash-es';
import Swatches from './swatches';
import BISForm from './bis-form';
import ProductOptions from './product-options';
import axios from 'axios';

export default {
  props: ['initialVariant', 'product', 'selectedVariant', 'options'],

  delimiters: ['#{', '}'],
  components: {
    'swatches': Swatches,
    'product-options': ProductOptions,
    'bis-form': BISForm,
  },
  mounted() {
    this.$emit('variant-changed', this.initialVariant)
  },
  data: function () {
    return {
      error: null,
      bisVisible: false,
      backInStockEnabled: true,
    }
  },

  methods: {
    buyNow() {
      this.error = null;
      let data = new FormData(this.$refs.form);
      let url = this.$refs.form.action;
      axios({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        window.location = '/checkout';
      })
      .catch(error => {
        console.err(error)
        this.error = error
      })
    },

    itemAdded() {
      var _learnq = window._learnq || [];
      _learnq.push(['track', 'Added to Cart', window.learnqItem]);
    }
  },

  computed: {
    addToCartButtonText() {
      if (this.selectedVariant.available) {
        if (this.product.tags.indexOf('preorder') > -1) {
          return 'Preorder'
        } else {
          return theme.strings.addToCart
        }
      } else {
        return theme.strings.soldOut
      }
    },


    buyNowButtonText() {
      if (this.selectedVariant.available) {
        if (this.product.tags.indexOf('preorder') > -1) {
          return 'Preorder Now'
        } else {
          return 'Buy Now'
        }
      } else {
        return theme.strings.soldOut
      }
    },

    selectedOptions() {
      return this.options.reduce((acc, option) => {
        const key = 'option' + option.position
        acc[key] = this.selectedVariant[key]
        return acc
      }, {})
    },

    soldOutVariants() {
      return filter(this.product.variants, function(variant) {
        return !variant.available;
      })
    },

    hasSoldOutVariants() {
      return this.soldOutVariants.length > 0;
    },
  },
  template: `
    <div class="bg-cream p-4 relative">

      <bis-form
        v-if="bisVisible && hasSoldOutVariants"
        :variants="soldOutVariants"
        :options="options"
        :product-id="product.id"
        @close="bisVisible = false"></bis-form>

      <form
        v-else
        ref='form'
        :disabled="!product.available"
        action="/cart/add"
        method="post"
        enctype="multipart/form-data"
        @submit="itemAdded"
        id="AddToCartForm">


        <div class="js f aic f-wrap jcb space-y-5 mb-6" v-if="product.variants.length > 1">
          <product-options
            v-on="$listeners"
            :options="options" :variants="product.variants"
            :initial-variant="initialVariant"
            ></product-options>
          <swatches v-if="!bisVisible && product.type != 'Gift Card'" :product="product"></swatches>
        </div>

        <div>
          <button
            :disabled="!selectedVariant.available"
            class="button"
            type="submit"
          >
            #{ addToCartButtonText }
          </button>

          <button
            v-if="selectedVariant.available"
            class="button button--secondary mt-4"
            type="button"
            @click.prevent.stop="buyNow"
          >
            #{ buyNowButtonText }
          </button>

          <p v-if="backInStockEnabled && hasSoldOutVariants" class="text-center pt-2">
            <a
              href="#"
              class="text-sm underline"
              @click.prevent.stop="bisVisible = true"
            >
              Get notified when your size is back in stock.
            </a>
          </p>

          <p v-if="error" class="text-center pt-2">#{ error }</p>
        </div>
      </form>
    </div>
  `
}
